import { render, staticRenderFns } from "./AccountsFooter.ts.vue?vue&type=template&id=e2d2e212"
import script from "./AccountsFooter.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountsFooter.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AccountsFooter.ts.vue?vue&type=style&index=0&id=e2d2e212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports